export class SummitNotification {
	constructor() {
		this.init();
	}

	init() {
		document.querySelectorAll('.summit-notification').forEach((notification) => {
			const closeButton = notification.querySelector('.summit-notification__close');

			if (!closeButton) {
				return;
			}

			closeButton.addEventListener('click', () => {
				notification.classList.add('summit-notification--closed');
			});
		});
	}
}
